export default {
    basicOrderInfo: {
        orderType: {},
        orderRows: [],
        customer: {
            firmName: '',
            firmBrokerTreeNodeId: -1,
            agentName: '',
            agentId: -1,
            agentBrokerTreeNodeId: -1,
            possibleProducts: []
        },
        emails: [],
        newEmail: {},
        sms: [],
        newSms: {},
        preventEmailsToBroker: false,
        preventEmailsToPhotographer: false,
        extraDeliveryRecipients: '',
        orderState: {}
    }
};
